import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import './index.css'; // Add this line if missing
import App from './App';
import reportWebVitals from './reportWebVitals';
import { trackEvent } from './utils/analytics';

// Silence console.log and console.debug in production
// console.warn and console.error are preserved for real issues
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
}

const container = document.getElementById('root');
const root = createRoot(container);

// root.render(
//   <AuthProvider>
//     <App />
//   </AuthProvider>
// );

root.render(
  <React.StrictMode>
    {/* <BrowserRouter> */}
      <AuthProvider>
        <App />
      </AuthProvider>
    {/* </BrowserRouter> */}
  </React.StrictMode>
);

// Field Core Web Vitals to GA4. CLS is a small fraction, so it is scaled to keep
// GA4's integer metric values meaningful.
reportWebVitals(({ name, value, delta, id }) => {
  const scale = name === 'CLS' ? 1000 : 1;
  trackEvent('web_vitals', {
    metric_name: name,
    metric_value: Math.round(value * scale),
    metric_delta: Math.round(delta * scale),
    metric_id: id,
    non_interaction: true,
  });
});
